module.exports = __webpack_public_path__ + "img/menuboard_mc_cafe_alt.57765047.webp";